import React, { useEffect, useState, useMemo, useCallback, memo, useRef } from "react";
import {
  Icon,
  Checkbox,
  Modal,
  Input,
  FormGroup,
  Form,
  FormField,
  Radio,
  Button,
} from "semantic-ui-react";

// serializer
import VenipunctureNoteSerializer from "issara-sdk/types/VenipunctureNoteSerializer_apps_LAB";

// Common
import PasswordRecheck from "react-lib/apps/common/PasswordRecheck";

// Interface
import { State, RunSequence } from "react-lib/apps/HISV3/LAB/sequence/LabReport";
import { LAB_STATUS } from "react-lib/apps/HISV3/LAB/LabInterface";

// Utils
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";
import SnackMessage from "react-lib/apps/common/SnackMessage";
import { Table } from "react-lib/frameworks/Table";

// Config
import { useIntl } from "react-intl";

// Types
type CardLabOrderCancelPackageProps = {
  setProp: (key: string, value: any) => any;
  onEvent: (e: any) => any;
  // seq
  runSequence: RunSequence;
  // data
  selectedLabOrderWorking: any;
  selectedVenipunctureNote?: VenipunctureNoteSerializer;
  selectedCentralLabBO?: Record<string, any>;
  // CommonInterface
  buttonLoadCheck?: any;
  errorMessage?: any;
  successMessage?: any;
  // callback
  onClose?: () => any;
  languageUX?: string;
};

const CARD_LAB_ORDER_CANCEL_PACKAGE = "CardLabOrderCancelPackage";

const CardLabOrderCancelPackage = (props: CardLabOrderCancelPackageProps) => {
  const intl = useIntl();
  const [checkedIds, setCheckedIds] = useState<number[]>([]);
  const [password, setPassword] = useState<string>("");

  const handleChecked = (item: any) => {
    let checkedData = checkedIds;
    const isChecked = checkedData.includes(item);
    const newChecked = isChecked ? checkedData.filter((id) => id !== item) : [...checkedData, item];

    setCheckedIds(newChecked);
  };

  const handleChangeData = (e: any, data: any) => {
    const name = data?.name || e.target.name;
    const value = data?.value ?? e.target.value;

    props.setProp(`selectedCentralLabBO.${name}`, value);
  };

  const getOrderStatus = (data: any = {}) => {
    return data?.central_lab_order_item_status === LAB_STATUS.REPORTED &&
      !data?.central_lab_result_is_authorized
      ? LAB_STATUS.PENDING_CONFIRM
      : data?.central_lab_order_item_status;
  };

  const packageOrderData = useMemo(() => {
    return (props.selectedCentralLabBO?.items || [])?.map((item: any) => {
      const status = getOrderStatus(item);

      return {
        ...item,
        chk: (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Checkbox
              disabled={status === LAB_STATUS.REPORTED || status === LAB_STATUS.PENDING_CONFIRM}
              checked={checkedIds.includes(item.package_order_id)}
              onChange={() => handleChecked(item.package_order_id)}
            />
          </div>
        ),
        lab_code: <div style={{ display: "flex", justifyContent: "center" }}>{item?.lab_code}</div>,
        name: `${item?.name || ""} (${item?.name_en || ""})`,
        central_lab_order_item_status: (
          <div style={{ display: "flex", justifyContent: "center" }}>{status}</div>
        ),
      };
    });
  }, [props.selectedCentralLabBO, checkedIds]);

  const packageOrderID = useMemo(() => {
    return (props.selectedCentralLabBO?.items || [])
      .filter(
        (item) =>
          getOrderStatus(item) !== LAB_STATUS.REPORTED &&
          getOrderStatus(item) !== LAB_STATUS.PENDING_CONFIRM,
      )
      .map((item) => item?.package_order_id);
  }, [props.selectedCentralLabBO]);

  const handleCancelPackage = () => {
    props.onEvent({
      message: "LabOrderArrive",
      params: {
        action: "cancelPackage",
        cardKey: CARD_LAB_ORDER_CANCEL_PACKAGE,
        password: password,
        checkedIds: checkedIds,
        callback: () => {
          props.onClose?.();
        },
      },
    });
  };

  const handleCheckAll = (e: any, v: any) => {
    if (v.checked) {
      setCheckedIds(packageOrderID || []);
    } else {
      setCheckedIds([]);
    }
  };

  const packageColumns = [
    {
      Header: (
        <Checkbox
          checked={checkedIds.length === packageOrderID.length && packageOrderID.length > 0}
          onChange={handleCheckAll}
        />
      ),
      width: 60,
      accessor: "chk",
    },
    {
      Header: "Code",
      width: 100,
      accessor: "lab_code",
    },
    {
      Header: "ชื่อ Package / รายการตรวจ",
      accessor: "name",
    },
    {
      Header: "สถานะ",
      width: 150,
      accessor: "central_lab_order_item_status",
    },
  ];

  return (
    <div className="ui form">
      <SnackMessage
        onEvent={props.onEvent}
        onClose={() => {
          props.setProp(`errorMessage.${CARD_LAB_ORDER_CANCEL_PACKAGE}`, null);
          props.setProp(`successMessage.${CARD_LAB_ORDER_CANCEL_PACKAGE}`, null);
        }}
        error={props.errorMessage?.[CARD_LAB_ORDER_CANCEL_PACKAGE]}
        success={props.successMessage?.[CARD_LAB_ORDER_CANCEL_PACKAGE]}
        languageUX={props.languageUX}
      />

      <div style={{ paddingBottom: "10px" }}>
        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            padding: "0.35rem 0 0.35rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <div>
              <label style={{ color: "#164A73" }}>ยกเลิก Package / รายการตรวจ</label>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  color: "rgba(117, 117, 117, 0.5)",
                  paddingTop: "10px",
                }}
              >
                <div>
                  <label style={{ paddingRight: "8px" }}>LabID</label>
                  <label>{props.selectedLabOrderWorking?.id || ""}</label>
                </div>
                <div>•</div>
                <div>
                  <label>{props.selectedLabOrderWorking?.date || ""}</label>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Icon className="red" link={true} name="close" onClick={props.onClose}></Icon>
          </div>
        </div>
        <hr></hr>
      </div>
      <div>
        <Form>
          <FormGroup>
            <FormField width={16}>
              <div>
                <Table
                  className="--rt-tbody-overflow-y-hidden"
                  columns={packageColumns}
                  data={packageOrderData}
                  minRows="10"
                  showPagination={false}
                  style={{ height: "50vh" }}
                ></Table>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={16}>
              <div style={{ display: "flex", fontWeight: "bold", margin: "10px 0px" }}>
                <label>เหตุผลในการยกเลิก</label>
                <span style={{ color: "red" }}>*</span>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <textarea
                  rows={4}
                  name="remark"
                  placeholder="ระบุเหตุผลในการยกเลิก..."
                  value={props.selectedCentralLabBO?.remark || ""}
                  style={{ width: "100%", resize: "none" }}
                  onChange={handleChangeData}
                />
              </div>
            </FormField>
          </FormGroup>
          <FormGroup inline style={{ marginTop: "10px" }}>
            <FormField width={6}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  gap: 10,
                }}
              >
                <label style={{ whiteSpace: "nowrap" }}>รหัสผ่าน</label>

                <div style={{ flex: 1 }}>
                  <PasswordRecheck
                    password={password}
                    setPassword={setPassword}
                    placeholder={intl.formatMessage({ id: "ระบุรหัสผ่าน" })}
                  />
                </div>
              </div>
            </FormField>

            <FormField
              width={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div>
                <Button
                  onClick={props.onClose}
                  size="small"
                  style={{
                    background: "#ADADAD",
                    color: "white",
                  }}
                >
                  {intl.formatMessage({ id: "ปิดหน้าต่าง" })}
                </Button>

                <ButtonLoadCheck
                  setProp={props.setProp}
                  onClick={handleCancelPackage}
                  paramKey={`${CARD_LAB_ORDER_CANCEL_PACKAGE}_cancelPackage`}
                  buttonLoadCheck={
                    props.buttonLoadCheck?.[`${CARD_LAB_ORDER_CANCEL_PACKAGE}_cancelPackage`]
                  }
                  color="red"
                  size="small"
                  title={`ยกเลิก Package (${checkedIds.length})`}
                />
              </div>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    </div>
  );
};

CardLabOrderCancelPackage.displayName = "CardLabOrderCancelPackage";

export default memo(CardLabOrderCancelPackage);
